// @ts-nocheck
/* Port of VersionBadge.js (8L). BYTE-IDENTICAL. */
import React from 'react';

const VersionBadge = ({ version }: any) => (
  <span className="rc-version">v{version}</span>
);

export default VersionBadge;
